/**
 * The platform's verification mark: a bowl of hot food, in the brand colour.
 *
 * Ours rather than borrowed. Every platform's mark is a check inside a circle or
 * a scalloped seal, and a customer reads those as "this app verified this
 * account" — which is exactly the claim we want to make, in a shape that is this
 * product's own subject rather than a copy of somebody else's. The steam is what
 * keeps it reading as hot food at sixteen points instead of as a semicircle.
 *
 * Drawn here rather than in either app because two of them show it: the
 * customer's storefront and tracking card, and the merchant's own Settings line.
 * One drawing, so the mark a merchant sees is the mark their customers see.
 *
 * @param props Size in points, and an optional colour override.
 * @returns The mark, as a decorative glyph — the control around it carries the label.
 */
import Svg, { Path } from 'react-native-svg';

import { useTheme } from '../providers/appearance';

export function VerifiedBowl({ size = 21, color }: { size?: number; color?: string }) {
  const theme = useTheme();
  const fill = color ?? theme.palette.primary;

  return (
    <Svg width={size} height={size} viewBox="0 0 24 24">
      {/* The bowl, filled: a silhouette survives being drawn small where an
          outline loses its interior first. */}
      <Path d="M3.4 11.8h17.2a8.6 8.6 0 0 1-17.2 0z" fill={fill} />
      {/* Its base, a hair wider than the bowl, so the two do not read as one blob. */}
      <Path d="M2 11.8h20" stroke={fill} strokeWidth={2.2} strokeLinecap="round" />
      {/* Steam. */}
      <Path
        d="M9.3 8.4c0-1.3 1.5-1.5 1.5-2.9M13.4 8.4c0-1.3 1.5-1.5 1.5-2.9"
        stroke={fill}
        strokeWidth={1.8}
        strokeLinecap="round"
        fill="none"
      />
    </Svg>
  );
}
